import AuthContainer from "../../components/Auth/AuthContainer";
import "../../index.css";

const Auth = () => {
  return (
    <div className="container-fluid vh-100 gradient-custom">
      <AuthContainer />
    </div>
  );
};

export default Auth;
